// src/redux/features/exchangeRatesApi.ts

import { api } from '../services/api';

export interface ExchangeRate {
  CharCode: string;
  Value: string | number;
  Name?: string;
  Nominal?: string | number;
}

export interface ExchangeRatesResponse {
  Date?: string;
  Valute?: ExchangeRate[];
}

export const exchangeRatesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getExchangeRates: builder.query<ExchangeRatesResponse, void>({
      query: () => ({
        url: '/app/exchange-rates/',
        method: 'GET',
      }),

      providesTags: ['ExchangeRates'],
    }),
  }),
});

export const { useGetExchangeRatesQuery } = exchangeRatesApi;
